import { useEffect, useRef } from "react";

export const useSidebarIndicator = (items) => {
  const hasInitialized = useRef(false);
  const isForcedLast = useRef(false);
  
  useEffect(() => {
    if (!items.length) return;
    
    const elements = document.querySelectorAll(items.map((el) => el.link).join(","));
    const indicator = document.querySelector(".article__sidebar-indicator");
    const allLinks = document.querySelectorAll(".article__sidebar-link");
    
    const setIndicatorPosition = (linkElement) => {
      if (!indicator || !linkElement) return;
      
      const parent = linkElement.closest(".article__sidebar-list");
      if (!parent) return;
      
      const parentRect = parent.getBoundingClientRect();
      const activeRect = linkElement.getBoundingClientRect();
      const offsetTop = activeRect.top - parentRect.top;
      
      indicator.style.top = `${offsetTop}px`;
    };
    
    const activateLink = (linkElement) => {
      if (!linkElement) return;
      
      allLinks.forEach((link) => link.classList.remove("active"));
      linkElement.classList.add("active");
      setIndicatorPosition(linkElement);
    };
    
    const initialize = () => {
      if (hasInitialized.current) return;
      
      const firstLink = allLinks[0];
      if (firstLink) {
        activateLink(firstLink);
        hasInitialized.current = true;
      }
    };
    
    setTimeout(initialize, 0);
    
    const cb = (entries) => {
      if (isForcedLast.current) return;
      
      const visible = entries.filter((entry) => entry.isIntersecting);
      const activeEntry = visible[0];
      
      if (!activeEntry) return;
      
      const activeLink = document.querySelector(
        `[data-intersectionlkey="#${activeEntry.target.id}"]`
      );
      
      if (activeLink) {
        activateLink(activeLink);
      }
    };
    
    const io = new IntersectionObserver(cb, {
      rootMargin: "-30% 0px -70% 0px",
      threshold: 0,
    });
    
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const scrolledToBottom =
        window.innerHeight + scrollTop >= document.body.scrollHeight - 2;
      
      if (scrolledToBottom) {
        const lastLink = allLinks[allLinks.length - 1];
        if (lastLink) {
          isForcedLast.current = true;
          activateLink(lastLink);
        }
      } else {
        isForcedLast.current = false;
      }
    };
    
    window.addEventListener("scroll", handleScroll);
    
    elements.forEach((el) => {
      if (el) io.observe(el);
    });
    
    return () => {
      window.removeEventListener("scroll", handleScroll);
      io.disconnect();
    };
  }, [items]);
};
